import React, { useContext } from 'react';
import { Checkbox } from 'antd';
import ProCard from '@ant-design/pro-card';
import { TypeReducerContext } from '../BulkDownload';

const options = [
  { label: 'Proposal', value: 'PROPOSAL' },
  { label: 'Extension', value: 'EXTENSION' },
  { label: 'Progress report', value: 'PROGRESS_REPORT' },
  { label: 'Completion report ', value: 'COMPLETION_REPORT' },
  { label: 'Proposal revision', value: 'PROPOSAL_REVISION' },
  { label: 'Withdrawal', value: 'WITHDRAWAL' },
];

const SelectDownloadType = () => {
  const [state, dispatch] = useContext(TypeReducerContext);
  const handleOnChange = (checkedValues) => {
    dispatch({ type: 'SELECT', payload: checkedValues });
  };

  return (
    <ProCard title="Select files to download:">
      <Checkbox.Group
        options={options}
        defaultValue={state}
        onChange={handleOnChange}
      />
    </ProCard>
  );
};

export default SelectDownloadType;
